import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Button } from '@grandvisionhq/common';

var AddToCart = (_param)=> {
    var { className  } = _param, props = swcHelpers.objectWithoutProperties(_param, [
        "className"
    ]);
    return React.createElement(Button, swcHelpers.extends({
        "data-t": "add-to-cart",
        className: classnames('add-to-cart', className)
    }, props));
};

export { AddToCart };
//# sourceMappingURL=AddToCart.js.map
